// Texture Parser
//
// Converts different file formats to an array of PIXI textures
// These are used by most objects
//

textureParser = {};
textureParser.textureLists = {};

textureParser.getClonedTextureList = function (name) {
  var textures = textureParser.getTextureList(name);

  var clonedList = [];
  for (var i = 0; i < textures.length; i++) {
    clonedList.push(textures[i].clone());
  }

  return clonedList;
};

textureParser.getTextureList = function (name) {
  if (typeof textureParser.textureLists[name] === "undefined") {
    console.error("Undefined textures - " + name);
    return;
  }

  if (!textureParser.textureLists[name].created) {
    textureParser.createTextures(name);
  }

  return textureParser.textureLists[name].textures;
};

textureParser.getTotalFrames = function (name) {
  return textureParser.textureLists[name].json.totalFrames;
};

textureParser.getFilesRequired = function (name) {
  var filesRequired = [];
  if (typeof name === "undefined") {
    // Undefined name in textureParser
    console.error("Undefined name in textureParser");
    return;
  }

  var textureObject = textureParser.textureLists[name];
  if (Reflex.developerModeData.singleFrameMovies) {
    switch (textureObject.json.format) {
      case "list":
        {
          textureObject.json.files = [textureObject.json.files[0]];
        }
        break;

      case "spriteSheet":
        {
        }
        break;

      case "files":
        {
          textureObject.json.totalFrames = 1;
        }
        break;
    }
  }

  if (typeof textureObject === "undefined") {
    console.error(
      "TextureList '" + name + "' was not found in config texture lists"
    );
    return;
  }

  switch (textureObject.json.format) {
    case "list":
      {
        for (var i = 0; i < textureObject.json.files.length; i++) {
          filesRequired.push(textureObject.json.files[i]);
        }
      }
      break;

    case "spriteSheet":
      {
        filesRequired.push(
          ReflexLoader.rootResDir + textureObject.json.fileName
        );
      }
      break;

    case "files":
      {
        // Creates a texture array where textures are loaded from individual, sequentially named files
        var fileRootIndex =
          typeof textureObject.json.baseFileIndex === "undefined"
            ? 0
            : textureObject.json.baseFileIndex;
        var step =
          typeof textureObject.json.fileIndexStep === "undefined"
            ? 1
            : textureObject.json.fileIndexStep;

        for (var i = 0; i < textureObject.json.totalFrames; i++) {
          filesRequired.push(
            ReflexLoader.rootResDir +
              sprintf(
                textureObject.json.filenameFormat,
                fileRootIndex + i * step
              )
          );
        }
      }
      break;

    case "staticSymbols":
      {
        // Creates a texture array from the symbol names based on "configuration.symbols" in layout.json
        var symbolsList = resourceManager.getConfiguration().symbols;
        for (var prop in symbolsList) {
          if (typeof symbolsList[prop] === "object") {
            filesRequired.push(
              ReflexLoader.rootResDir + symbolsList[prop].fileName
            );
          }
        }
      }
      break;

    default: {
      console.error(
        "Unsupported texture parser type - " + textureObject.json.format
      );
    }
  }

  return filesRequired;
};

textureParser.createTextures = function (name) {
  var textureObject = textureParser.textureLists[name];

  switch (textureObject.json.format) {
    case "list":
      {
        for (var i = 0; i < textureObject.json.files.length; i++) {

          var fileName = textureObject.json.files[i];
          // need to see if the file is in an atlas.
          // if its not, then we stick with the original <&social&>
          if (fileName.indexOf('<&social&>') !== -1) {
            const tempFilename = fileName.replaceAll('<&social&>', gdk.isSocial() === true ? '_Social' : '');
            if(ReflexLoader.fileAtlasData[gdk.ammendResourceName(ReflexLoader.rootResDir + tempFilename)]) {
              // file is in an atlas, we need the converted name
              fileName = tempFilename;
            }
          }           

          textureObject.textures.push(
            new PIXI.Texture.fromImage(
              gdk.ammendResourceName(
                ReflexLoader.rootResDir + fileName
              ),
              "use-credentials"
            )
          );
        }
      }
      break;

    case "spriteSheet":
      {
        // Check file loaded
        if (
          typeof PIXI.utils.TextureCache[
            ReflexLoader.rootResDir + textureObject.json.fileName
          ] === "undefined"
        ) {
          console.log(
            "Spritesheet " +
              textureObject.json.fileName +
              " was not found in texture memory, could not create textureList"
          );
          return;
        }

        // Creates a texture array where textures ar part of a sprite sheet with fixed width / height
        var frameWidth =
          PIXI.utils.TextureCache[
            ReflexLoader.rootResDir + textureObject.json.fileName
          ].width / textureObject.json.gridWidth;
        var frameHeight =
          PIXI.utils.TextureCache[
            ReflexLoader.rootResDir + textureObject.json.fileName
          ].height / textureObject.json.gridHeight;
        if (
          checkForDefined(
            PIXI.utils.TextureCache[
              ReflexLoader.rootResDir + textureObject.json.fileName
            ].trim
          )
        ) {
          console.error("Error loading sprite sheet '" + name + "'");
          console.error(
            "Sprite sheets contained within Atlasses are not supported, this may give unsupported behaviour"
          );
          console.error(
            "Split your sprite sheets into individual files before atlassing"
          );
        }

        for (var i = 0; i < textureObject.json.totalFrames; i++) {
          var x = i % textureObject.json.gridWidth;
          var y = Math.floor(i / textureObject.json.gridWidth);
          var frameTexture = new PIXI.Texture(
            PIXI.utils.TextureCache[
              ReflexLoader.rootResDir + textureObject.json.fileName
            ],
            "use-credentials"
          );
          frameTexture.frame = new PIXI.Rectangle(
            x * frameWidth,
            y * frameHeight,
            frameWidth,
            frameHeight
          );
          textureObject.textures.push(frameTexture);
        }
      }
      break;

    case "files":
      {
        // Creates a texture array where textures are loaded from individual, sequentially named files
        var fileRootIndex =
          typeof textureObject.json.baseFileIndex === "undefined"
            ? 0
            : textureObject.json.baseFileIndex;
        var step =
          typeof textureObject.json.fileIndexStep === "undefined"
            ? 1
            : textureObject.json.fileIndexStep;

        for (var i = 0; i < textureObject.json.totalFrames; i++) {
          var fileName = sprintf(
            textureObject.json.filenameFormat,
            fileRootIndex + i * step
          );

          // need to see if the file is in an atlas.
          // if its not, then we stick with the original <&social&>
          if (fileName.indexOf('<&social&>') !== -1) {
            const tempFilename = fileName.replaceAll('<&social&>', gdk.isSocial() === true ? '_Social' : '');
            if(ReflexLoader.fileAtlasData[gdk.ammendResourceName(ReflexLoader.rootResDir + tempFilename)]) {
              // file is in an atlas, we need the converted name
              fileName = tempFilename;
            }
          }          

          textureObject.textures.push(
            new PIXI.Texture.fromImage(
              gdk.ammendResourceName(ReflexLoader.rootResDir + fileName),
              "use-credentials"
            )
          );
        }
      }
      break;

    case "staticSymbols":
      {
        // Creates a texture array from each symbol based on "configuration.symbols" in layout.json
        var symbolsList = resourceManager.getConfiguration().symbols;
        for (var prop in symbolsList) {
          if (typeof symbolsList[prop] === "object") {
            // Add the first texture of each symbol
            textureObject.textures.push(
              textureParser.getTextureList(symbolsList[prop].texture)[0]
            );
          }
        }
      }
      break;

    default: {
      console.error(
        "Unsupported texture parser type - " + textureObject.json.format
      );
      return;
    }
  }

  // Check all textures have loaded
  for (var i = 0; i < textureObject.length; i++) {
    if (textureObject[i].baseTexture.hasLoaded === false) {
      console.error(
        "Texture was not pre loaded before textureParser tried to use textureList " +
          name
      );
    }
  }

  textureObject.created = true;
};

textureParser.addTextureList = function (name, json) {
  var textureObject = {};
  textureObject.name = name;
  textureObject.json = json;
  textureObject.textures = [];
  textureObject.created = false;

  textureParser.textureLists[name] = textureObject;
};

// By default, we have static symbols as a texture list
textureParser.addTextureList("staticSymbols", { format: "staticSymbols" });
